<template>
  <v-btn
    v-if="item[header.value]"
    text
    :href="dynamicFormLink.href"
    light
    color="primary"
    :disabled="header.permission ? !canPerformAction('VIEW_OFFER') : false"
    class="text-capitalize"
  >
    {{ header.label }}
  </v-btn>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppLinkContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    header: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(['canPerformAction']),
    dynamicFormLink () {
      return this.$router.resolve({
        name: this.header.routeName,
        params: {
          contentTypeLabel: this.header.contentTypeLabel,
          mode: this.header.mode,
          uuid: this.item[this.header.value]
        }
      });
    }
  }
};
</script>
